import { render, staticRenderFns } from "./GigReviewSection.vue?vue&type=template&id=1e9f1c3e&scoped=true&"
import script from "./GigReviewSection.vue?vue&type=script&lang=js&"
export * from "./GigReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./GigReviewSection.vue?vue&type=style&index=0&id=1e9f1c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9f1c3e",
  null
  
)

export default component.exports